module.exports = __webpack_public_path__ + "img/logo_retangulo_menor.91fa674b.png";